export default __webpack_public_path__ + "static/media/logo_gui.bc15af83.png";